export default __webpack_public_path__ + "static/media/logo_orange_sm.e914d157.png";